import { TableActionsMenuContext } from "./table-actions-menu.context";
import type { TableActionsMenuProps } from "./types-table-actions-menu";
import { useTableActionsMenu } from "./use-table-actions-menu";
import { TableActionsMenuView } from "./view-table-actions-menu";

export function TableActionsMenuRoot({ children, ...options }: TableActionsMenuProps) {
  const viewModel = useTableActionsMenu(options, children);

  return (
    <TableActionsMenuContext.Provider value={viewModel.context}>
      <TableActionsMenuView
        trigger={viewModel.trigger}
        menuRef={viewModel.menuRef}
        model={viewModel.model}
        menuPt={viewModel.menuPt}
        panelClassName={viewModel.classNames.panel}
        panelStyle={viewModel.panelStyle}
        onShow={viewModel.onShow}
        onHide={viewModel.onHide}
        onKeyDownCapture={viewModel.onKeyDownCapture}
        onKeyDown={viewModel.onKeyDown}
        testId={viewModel.testId}
        className={viewModel.className}
        style={viewModel.style}
        rest={viewModel.rest}
      />
    </TableActionsMenuContext.Provider>
  );
}
TableActionsMenuRoot.displayName = "TableActionsMenu.Root";
